export const ENV = {
  VITE_FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL as string,
  VITE_BACKEND_API_URL: import.meta.env.VITE_BACKEND_API_URL as string,
};
